export default __webpack_public_path__ + "static/media/thanRed.97462f2c.svg";